import { labeled, boolean, stringRequired, custom } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  custom(Joi)
    .object()
    .keys({
      avoidingRiskOfIncreasingVariableInterestRate: boolean(Joi).label(
        labeled(
          label,
          'Avoiding risk of increasing variable interest rate during fixed interest period'
        )
      ),
      makeBudgetingEasier: boolean(Joi).label(labeled(label, 'Make budgeting easier')),
      other: boolean(Joi).label(labeled(label, 'Other'))
    })
    .orValue('avoidingRiskOfIncreasingVariableInterestRate', 'makeBudgetingEasier', 'other')
    .label(label)
    .when('.other', {
      is: true,
      then: Joi.object({
        otherComments: stringRequired(Joi, 1, 4096).label(labeled(label, 'Details'))
      })
    });

export default {
  schema
};
